import React from 'react';
import { CheckCircle, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const VisaProcessSupport: React.FC = () => {
    const navigate = useNavigate();

    const handleContactClick = () => {
        navigate('/eligibility?service=immigration');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20">
            <div className="bg-[#009B8F] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">Visa Process Support</h1>
                    <p className="text-xl text-white/90 max-w-2xl">
                        Making your pre-departure stage smooth and stress-free.
                    </p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className="p-3 bg-[#009B8F]/10 rounded-full">
                        <Calendar className="text-[#009B8F] w-8 h-8" />
                    </div>
                    <h2 className="text-3xl font-serif text-[#011E26]">Seamless Pre-Departure Assistance</h2>
                </div>

                <div className="prose prose-lg text-slate-600 max-w-none">
                    <p className="mb-4">
                        Our Visa Process Support service is designed to make the pre-departure stage as smooth and stress-free as possible. At NexOverseas, we understand that securing a visa is just one part of the journey, students also need practical assistance with appointments, procedures, and preparations before leaving for their destination.
                    </p>

                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#009B8F] mb-8">
                        <h3 className="text-lg font-bold text-[#011E26] mb-3 uppercase tracking-wide">Through this service, we help students:</h3>
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            {[
                                "Schedule and manage visa appointments efficiently, reducing delays and confusion",
                                "Navigate pre-departure procedures, including document verification and compliance checks",
                                "Receive guidance on any additional steps required by immigration authorities to ensure a smooth approval process",
                                "Stay informed about timelines, deadlines, and next steps, so they are fully prepared before travel"
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-2 text-sm font-medium">
                                    <CheckCircle className="w-5 h-5 text-[#009B8F] flex-shrink-0" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <p className="mb-6">
                        By assisting with these critical steps, NexOverseas ensures that students experience a well-organized and stress-free visa journey. This proactive support helps students focus on preparing for their studies and settling into their new environment with confidence.
                    </p>

                    <button
                        onClick={handleContactClick}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg"
                    >
                        Get in Touch Today
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VisaProcessSupport;
